import React from "react";
import "./Radio.css";

const RadioNameonly = ({ label, value, onChange, options, withIcon, disabled }) => {
  return (
    <div className="radio">
      {label && <span className="radio-label">{label}</span>}
      <span className="radio-for-nameonly"></span>
      <div className={"radio-component " + (disabled ? "disabled" : "")}>
        {options?.map((option, index) => {
          return (
            <div
              className={
                (value === option.value ? "activeRadio" : "radioItem") +
                " " +
                (option.disabled ? "disabled" : "")
              }
              key={index}
              onClick={() => {
                if (!option.disabled || disabled) onChange(option.value);
              }}
            >
              {withIcon ? (
                <img className={"radio-icon"} src={option.icon} alt="" />
              ) : (
                option.label
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RadioNameonly;
